export enum ConditionEnum {
  BEFORE = 'BEFORE',
  ON = 'ON',
  AFTER = 'AFTER',
}
